// extracted by mini-css-extract-plugin
export var closedMsg = "Panel_closedMsg__EOdOl";
export var container = "Panel_container__LIIBw";
export var freeShipping = "Panel_freeShipping__JTD4d";
export var noMargin = "Panel_noMargin__itgBS";
export var open = "Panel_open__o2NyP";
export var panelContainer = "Panel_panelContainer__LlfKR";
export var productGridWrapper = "Panel_productGridWrapper__mgZSa";
export var reviewSubscriptions = "Panel_reviewSubscriptions__mrWGq";
export var status = "Panel_status__SaOqL";
export var statusContainer = "Panel_statusContainer__73hRM";
export var statusLight = "Panel_statusLight__0P3Qz";
export var summaryDetails = "Panel_summaryDetails__SoZ41";
export var title = "Panel_title__wGzIM";
export var titleContainer = "Panel_titleContainer__59H6v";